import structure from "./action-types";
import axios from "axios";
import { showSuccess, showError } from "../../app/toastify";
import commonTypes from "../common/action-types";
import download from "downloadjs";

const types = { ...commonTypes, ...structure };

export const getDegrees = () => {
  return async (dispatch) => {
    try {
      const { data } = await axios.get("/api/users/degrees");

      dispatch({
        type: types.SET_DEGREES,
        data,
      });
    } catch (error) {
      showError(error);
    }
  };
};

export const getSpecializations = () => {
  return async (dispatch) => {
    try {
      const { data } = await axios.get("/api/users/specializations");

      dispatch({
        type: types.SET_SPECIALIZATIONS,
        data,
      });
    } catch (error) {
      showError(error);
    }
  };
};

export const getSystemUsers = () => {
  return async (dispatch) => {
    try {
      dispatch({ type: types.START_LOADING });

      dispatch({
        type: types.SET_SYSTEM_USERS,
        data: [],
      });

      const { data } = await axios.get("/api/users/system-users");

      dispatch({ type: types.END_LOADING });

      dispatch({
        type: types.SET_SYSTEM_USERS,
        data,
      });
    } catch (error) {
      dispatch({ type: types.END_LOADING });
      showError(error);
    }
  };
};

export const addNewSystemUser = (formData, onClose) => {
  return async (dispatch) => {
    try {
      dispatch({ type: types.START_WAIT });
      dispatch({ type: types.START_LOADING });

      const { data } = await axios.post("/api/users/system-users", formData);
      onClose();

      dispatch({ type: types.END_LOADING });
      dispatch({ type: types.END_WAIT });

      dispatch({
        type: types.ADD_OR_UPDATE_SYSTEM_USER,
        data,
      });
      showSuccess("Saved successfully");
    } catch (error) {
      dispatch({ type: types.END_LOADING });
      dispatch({ type: types.END_WAIT });
      showError(error);
    }
  };
};

export const removeSystemUser = ({ userEntityId, role }, setShowDialog) => {
  return async (dispatch) => {
    try {
      dispatch({ type: types.START_WAIT });
      dispatch({ type: types.START_LOADING });

      await axios.post("/api/users/delete-system-users", {
        userEntityId,
        role,
      });

      setShowDialog(false);

      dispatch({ type: types.END_LOADING });
      dispatch({ type: types.END_WAIT });

      dispatch({
        type: types.REMOVE_SYSTEM_USER,
        userEntityId,
      });
      showSuccess("Removed successfully");
    } catch (error) {
      dispatch({ type: types.END_LOADING });
      dispatch({ type: types.END_WAIT });
      showError(error);
    }
  };
};

export const ressetPassword = (formData, onClose) => {
  return async (dispatch) => {
    try {
      dispatch({ type: types.START_WAIT });
      dispatch({ type: types.START_LOADING });

      const { data } = await axios.post("/api/users/resset-password", formData);
      onClose();

      dispatch({ type: types.END_LOADING });
      dispatch({ type: types.END_WAIT });

      dispatch({
        type: types.ADD_OR_UPDATE_SYSTEM_USER,
        data,
      });

      showSuccess("Saved successfully");
    } catch (error) {
      dispatch({ type: types.END_LOADING });
      dispatch({ type: types.END_WAIT });
      showError(error);
    }
  };
};

export const getTeacherProfile = (teacherId) => {
  return async (dispatch) => {
    try {
      dispatch({
        type: types.SET_TEACHER_PROFILE,
        data: {},
      });

      dispatch({ type: types.START_LOADING });
      const { data } = await axios.get(
        "/api/users/teacher-profile/" + teacherId
      );

      dispatch({
        type: types.SET_TEACHER_PROFILE,
        data,
      });

      dispatch({ type: types.END_LOADING });
    } catch (error) {
      dispatch({ type: types.END_LOADING });
      showError(error);
    }
  };
};

export const updateTeacherResidence = (payload) => {
  return async (dispatch) => {
    try {
      dispatch({ type: types.START_LOADING });
      const { data } = await axios.post(
        "/api/users/teacher-residence",
        payload
      );

      dispatch({
        type: types.SET_TEACHER_PROFILE,
        data,
      });

      dispatch({ type: types.END_LOADING });
    } catch (error) {
      dispatch({ type: types.END_LOADING });
      showError(error);
    }
  };
};

export const getProfileDocumentTypes = () => {
  return async (dispatch) => {
    try {
      const { data } = await axios.get("/api/users/profile-document-types");

      dispatch({
        type: types.SET_PROFILE_DOCUMENT_TYPES,
        data,
      });
    } catch (error) {
      showError(error);
    }
  };
};

export const getProfileDocuments = (userId) => {
  return async (dispatch) => {
    try {
      const { data } = await axios.get(
        "/api/users/profile-documents/" + userId
      );

      dispatch({
        type: types.SET_PROFILE_DOCUMENTS,
        data,
      });
    } catch (error) {
      showError(error);
    }
  };
};

export const updateUserProfile = (payload) => {
  return async (dispatch) => {
    try {
      dispatch({ type: types.START_LOADING });
      const { data } = await axios.put("/api/users/profile", payload);

      dispatch({
        type: types.SET_TEACHER_PROFILE,
        data: data.user,
      });

      dispatch({
        type: types.SET_PROFILE_DOCUMENTS,
        data: data.profileDocuments,
      });

      dispatch({ type: types.END_LOADING });
    } catch (error) {
      dispatch({ type: types.END_LOADING });
      showError(error);
    }
  };
};

export const getSchoolLeadersEvaluations = () => {
  return async (dispatch) => {
    try {
      dispatch({ type: types.START_LOADING });

      const { data } = await axios.get("/api/users/school-leaders-evaluations");

      dispatch({
        type: types.SET_SCHOOL_LEADERS_EVALUATIONS,
        data,
      });

      dispatch({ type: types.END_LOADING });
    } catch (error) {
      dispatch({ type: types.END_LOADING });

      showError(error);
    }
  };
};

export const puplishSchoolLeadersEvaluations = (cb) => {
  return async (dispatch) => {
    try {
      const { data } = await axios.post(
        "/api/users/puplish-school-leaders-evaluations",
        {}
      );

      dispatch({
        type: types.SET_SCHOOL_LEADERS_EVALUATIONS,
        data,
      });

      showSuccess("Puplished successfully");

      cb();
    } catch (error) {
      showError(error);
    }
  };
};

export const downloadSchoolLeaderEvaluationPdf = (evaluationId) => {
  return async (dispatch) => {
    try {
      dispatch({ type: types.START_WAIT });
      dispatch({ type: types.START_LOADING });

      const { data } = await axios.get(
        "/api/users/school-leader-evaluation-pdf/" + evaluationId,
        {
          responseType: "blob",
        }
      );

      download(
        new Blob([data]),
        `school_leader_evaluation_${evaluationId}.pdf`,
        ".pdf"
      );

      dispatch({ type: types.END_LOADING });
      dispatch({ type: types.END_WAIT });
    } catch (error) {
      dispatch({ type: types.END_LOADING });
      dispatch({ type: types.END_WAIT });
      showError(error);
    }
  };
};

// Appeal Actions
export const submitAppeal = (appealData, onSuccess) => {
  return async (dispatch) => {
    try {
      dispatch({ type: types.START_WAIT });
      dispatch({ type: types.START_LOADING });

      const { data } = await axios.post(
        "/api/users/school-leader-evaluation-appeal",
        appealData
      );

      dispatch({ type: types.END_LOADING });
      dispatch({ type: types.END_WAIT });

      showSuccess("Appeal submitted successfully");
      if (onSuccess) onSuccess();

      // Refresh evaluations to show appeal status
      dispatch(getSchoolLeadersEvaluations());
    } catch (error) {
      dispatch({ type: types.END_LOADING });
      dispatch({ type: types.END_WAIT });
      showError(error);
    }
  };
};

export const getAppealByEvaluation = (evaluationId) => {
  return async (dispatch) => {
    try {
      const { data } = await axios.get(
        `/api/users/appeal-by-evaluation/${evaluationId}`
      );

      dispatch({
        type: types.SET_CURRENT_APPEAL,
        data,
      });
    } catch (error) {
      showError(error);
    }
  };
};

export const getMyAppeals = () => {
  return async (dispatch) => {
    try {
      dispatch({ type: types.START_LOADING });

      const { data } = await axios.get("/api/users/my-appeals");

      dispatch({
        type: types.SET_MY_APPEALS,
        data,
      });

      dispatch({ type: types.END_LOADING });
    } catch (error) {
      dispatch({ type: types.END_LOADING });
      showError(error);
    }
  };
};
